import './_styles.scss';
import React from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';

export default ({ label, onClickEvent, backButtonLabel, onClickBackButton, loading }) => {

  const WrapperType = (!!backButtonLabel) ? 'Double' : 'Single';

  return (
    <div className={`Button-Wrapper ${WrapperType}`}>

      { (!!backButtonLabel) &&
        <button className='Back-Button' onClick={onClickBackButton} disabled={!!loading}>
          <MdKeyboardArrowLeft className='icon'/>
          <span>{backButtonLabel}</span>
        </button>
      }

      <button className='Button' onClick={onClickEvent} disabled={!!loading}>
        {label}
      </button>

    </div>
  );
}
